<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">テンプレート</div>
    <div class="row m-0 w-100" style="padding:40px;">
      <div class="row pb-4">
        <p class="mb-0 pb-0 acry-text-title">データ作成はテンプレートをダウンロードして作成をお願いします。</p>
      </div>
      <div class="d-flex flex-column align-items-center">
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold; stroke-width:40px;" @click="clickDownloadBtn(0)">
          <div class="pe-none">S サイズ W61xH100xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold;" @click="clickDownloadBtn(1)">
          <div class="pe-none">M サイズ W92xH150xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
        <div class="d-flex m-1 acry-btn-secondary-normal dl-btn justify-content-center align-items-center c-pointer" style="font-weight: bold;" @click="clickDownloadBtn(2)">
          <div class="pe-none">L サイズ W139xH225xD3(mm)<i class="bi bi-download ms-2"></i></div>
        </div>
      </div>
      <div class="align-items-center d-flex flex-column text-start" style="border-radius: 10px; background: #F5F7FA; border-radius: 10px; width: 502px; height: 95px; margin: 32px auto; font-size: 14px; padding: 16px;">
        <p class="m-0 w-100">・作成するサイズのテンプレートをダウンロードし作成してください。</p>
        <p class="m-0 w-100">・adobe  Illustrat バージョン CS 以上対応</p>
        <p class="m-0 w-100">・デザイン作成の詳しい方法は<span class="c-pointer" style="text-decoration: underline; color: #8C9BC6;" @click="onClickHelp()">データ作成ガイド</span>を参考にしてください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "CenterViewInfo_Ap",
  props: {},
  data: function () {
    return {
    };
  },
  computed: {

  },
  created: function () {
    this.$store.commit("hideRightMenu");
  },
  components: {
  },
  methods: {
    clickDownloadBtn(index){
      Analytics.designTemplateDownload(['S', 'M', 'L'][index]);
      const files = ['ACRYPRO_regulationS.zip', 'ACRYPRO_regulationM.zip', 'ACRYPRO_regulationL.zip'];
      let link = document.createElement("a");
      link.href = 'template/' + files[index];
      link.download = files[index];
      link.click();
    },
    onClickHelp(){
      window.open('https://www.acry.jp/datacreationguide');
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.dl-btn {
  height: 42px;
  width: 400px;
}
</style>
